import { Link } from "react-router-dom"
import { Button } from "./ui/button"

function NotFound() {
    return(
        <>
            <main className="bg-foreground flex flex-col h-screen w-screen items-center justify-center">
                <section className="flex flex-col justify-center items-center rounded-full bg-secondary h-100 w-100 sm:h-150 sm:w-150 p-20 gap-4">
                    <div className="flex flex-col justify-center items-center w-full">
                        <h1 className="text-primary font-black text-9xl">404</h1>
                        <p className="text-primary font-semibold text-lg ">Feeling lost?</p>
                    </div>
                    <Button><Link to="/">Take me home</Link></Button>
                </section>
            </main>

            
        </>
    )
}


export default NotFound